<template>
  <nav class="navbar bg-primary navbar-expand-lg" data-bs-theme="dark" style="min-height: 56px">
    <div class="container-fluid">
      <span class="navbar-brand"
        >CarClean <i class="material-icons inline-icon">handshake</i>
        {{ companyName }}</span
      >
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <ul class="navbar-nav text-end" id="navbar-links">
          <!--<li class="nav-item">
            <router-link class="nav-link active" aria-current="page" to="/">Home</router-link>
          </li>-->
          <li id="link-lista-os" class="nav-item">
            <router-link class="nav-link active" to="/lista-os"
              >Serviço</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link active" to="/monitor"
              >Painel</router-link
            >
          </li>

          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle active"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Ordem de Serviço
            </a>
            <ul class="dropdown-menu">
              <li>
                <router-link class="dropdown-item" to="/nova-os"
                  >Cadastrar</router-link
                >
              </li>
              <li>
                <router-link class="dropdown-item" to="/pesquisar-os"
                  >Pesquisar</router-link
                >
              </li>
              <li class="dropdown-divider"></li>
              <li>
                <router-link class="dropdown-item" to="/os-canceladas"
                  >Canceladas</router-link
                >
              </li>
              <li class="dropdown-divider"></li>
              <li>
                <router-link class="dropdown-item" to="/relatorio-dia"
                  >Relatório diário</router-link
                >
              </li>
              <li>
                <router-link class="dropdown-item" to="/relatorio-mes"
                  >Relatório mensal</router-link
                >
              </li>
            </ul>
          </li>

          <li id="link-gerencia" class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle active"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Gerência
            </a>
            <ul class="dropdown-menu">
              <li>
                <router-link class="dropdown-item" to="/sistema/veiculos"
                  >Veículos</router-link
                >
              </li>
              <li>
                <router-link class="dropdown-item" to="/sistema/vendedores"
                  >Vendedores</router-link
                >
              </li>
              <li>
                <router-link class="dropdown-item" to="/sistema/feriados"
                  >Feriados</router-link
                >
              </li>
              <li class="dropdown-divider"></li>
              <li>
                <router-link class="dropdown-item" to="/sistema/cores"
                  >Cores de veículos</router-link
                >
              </li>
              <li>
                <router-link class="dropdown-item" to="/sistema/prismas"
                  >Prismas</router-link
                >
              </li>
              <li class="dropdown-divider"></li>
              <li>
                <router-link class="dropdown-item" to="/relatorio-atrasos"
                  >Relatório de entregas</router-link
                >
              </li>
            </ul>
          </li>

          <li id="link-sistema" class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle active"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Sistema
            </a>
            <ul class="dropdown-menu">
              <!--<li>
                <router-link class="dropdown-item" to="/sistema/parametros">Parâmetros</router-link>
              </li>-->
              <li>
                <router-link class="dropdown-item" to="/sistema/usuarios"
                  >Usuários</router-link
                >
              </li>
              <li>
                <router-link class="dropdown-item" to="/sistema/dashboard"
                  >Painel de controle</router-link
                >
              </li>
              <li class="dropdown-divider"></li>
              <li>
                <router-link class="dropdown-item" to="/sistema/horarios-novos"
                  >Agenda novos</router-link
                >
              </li>
              <li>
                <router-link class="dropdown-item" to="/sistema/horarios-pos"
                  >Agenda Pós vendas</router-link
                >
              </li>
              <li>
                <router-link class="dropdown-item" to="/sistema/horarios-lexus"
                  >Agenda Lexus</router-link
                >
              </li>
              <li class="dropdown-divider"></li>
              <li>
                <router-link class="dropdown-item" to="/sistema/servicos"
                  >Serviços</router-link
                >
              </li>
              <li>
                <router-link class="dropdown-item" to="/relatorio-servicos"
                >Relatório de serviços</router-link
                >
              </li>
              <li>
                <router-link class="dropdown-item" to="/relatorio-veiculos-novos"
                >Relatório veículos novos</router-link
                >
              </li>
              <li>
                <router-link class="dropdown-item" to="/acompanhamento-diario"
                  >Acompanhamento diário</router-link
                >
              </li>
              <li class="dropdown-divider"></li>
              <li>
                <router-link class="dropdown-item" to="/certificados"
                  >Certificados</router-link
                >
              </li>
              <li>
                <router-link class="dropdown-item" to="/certificados/historico"
                  >Certificados emitidos</router-link
                >
              </li>
            </ul>
          </li>
        </ul>
        <ul id="module-inventory" class="navbar-nav d-none">
          <li class="nav-item">
            <a class="nav-link active cursor-pointer" href="/inventario/relatorios/visao-geral">Estoque</a>
          </li>
        </ul>
        <ul class="navbar-nav float-end" id="navbar-links-logout">
          <li class="nav-item cursor-pointer">
            <router-link class="nav-link active" to="/meu-perfil"
              >Meu perfil</router-link
            >
          </li>
          <li class="nav-item cursor-pointer">
            <a class="nav-link active" v-on:click="logout">Logout</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import Helper from "@/components/Helper.vue";
import { company } from "../../server.json";

export default {
  name: "Navbar",
  data() {
    return {
      companyName: "",
    };
  },
  mounted() {
    let logged = sessionStorage.getItem("jwt");
    if (logged) {
      Helper.checkPermissions();
    }

    this.companyName = company;
  },
  methods: {
    logout() {
      // Logout silencioso, apenas requisita destruição do token
      Helper.axiosRequest({
        url: "/logout",
        method: "POST",
        onSuccess: () => {
          sessionStorage.removeItem("jwt");
          sessionStorage.removeItem("user");
          sessionStorage.removeItem("tmp_prisms");
          sessionStorage.removeItem("tmp_services");
          sessionStorage.setItem("forceRefresh", "1");
          this.$router.push("/login");
        },
        onFail: () => {
          sessionStorage.removeItem("jwt");
          sessionStorage.removeItem("user");
          sessionStorage.removeItem("tmp_prisms");
          sessionStorage.removeItem("tmp_services");
          sessionStorage.setItem("forceRefresh", "1");
          this.$router.push("/login");
        },
      });
    },
  },
};
</script>

<style scoped>
nav {
  background-color: #0949a8 !important;
}
</style>
